import { lazy, Suspense, useEffect, useState } from 'react'
import { haalIk, opUitgelogd } from './lib/api'
import { navigeer, useRoute } from './lib/router'
import { lees, meld, useStaat, zet } from './lib/staat'
import Poort from './onderdelen/Poort'
import Shell from './onderdelen/Shell'
import { Foutvlak, Laden } from './onderdelen/ui'
import Overzicht from './onderdelen/Overzicht'

/* De schermen buiten het overzicht pas laden als iemand ze opent. */
const ControleScherm = lazy(() => import('./onderdelen/ControleScherm'))
const Storingen = lazy(() => import('./onderdelen/Storingen'))
const Logboek = lazy(() => import('./onderdelen/Logboek'))
const Database = lazy(() => import('./onderdelen/Database'))
const Pcs = lazy(() => import('./onderdelen/Pcs'))
const Configuratie = lazy(() => import('./onderdelen/Configuratie'))

type Stand = 'kijken' | 'binnen' | 'buiten' | 'fout'

export default function App() {
  const [stand, setStand] = useState<Stand>('kijken')
  const [reden, setReden] = useState<string | null>(null)
  const ik = useStaat((s) => s.ik)

  /* Een fout uit de adresbalk (?fout=geen-toegang) één keer tonen en dan
     weghalen, zodat hij er na verversen niet nog steeds staat. */
  const [fout] = useState(() => new URLSearchParams(location.search).get('fout'))
  useEffect(() => {
    if (!fout) return
    const u = new URL(location.href)
    u.searchParams.delete('fout')
    history.replaceState(null, '', u.pathname + u.search)
  }, [fout])

  useEffect(() => {
    opUitgelogd(() => { zet({ ik: null }); setStand('buiten') })
    void haalIk().then((s) => {
      if (!s) { setStand('buiten'); return }
      if ('fout' in s) { setReden(s.fout); setStand('fout'); return }
      zet({ ik: s.ik, terugval: s.terugval })
      setStand('binnen')
    })
  }, [])

  if (stand === 'kijken') return <div className="opstart"><Laden /></div>
  if (stand === 'fout') {
    return <div className="opstart"><div style={{ maxWidth: 520 }}><Foutvlak fout={reden ?? 'Er ging iets mis.'} opnieuw={() => location.reload()} /></div></div>
  }
  if (stand === 'buiten' || !ik) return <Poort fout={fout} />

  return (
    <Shell>
      <Suspense fallback={<Laden />}>
        <Scherm />
      </Suspense>
    </Shell>
  )
}

function Scherm() {
  const { delen } = useRoute()
  const [eerste, tweede] = delen
  switch (eerste) {
    case undefined: return <Overzicht />
    case 'controle': return tweede ? <ControleScherm id={tweede} /> : <Overzicht />
    case 'storingen': return <Storingen />
    case 'logboek': return <Logboek />
    case 'database': return <Database />
    case 'pcs': return <Pcs />
    case 'configuratie': return <Configuratie />
    default: return <NietGevonden />
  }
}

function NietGevonden() {
  useEffect(() => {
    if (lees().ik) {
      meld('Dat adres bestaat hier niet. Je bent terug op het overzicht.', 'info')
      navigeer('/', true)
    }
  }, [])
  return null
}
